import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid, List, ListItem } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import TrendDePastrareClientiTrimestru from '../TrendDePastrareClientiTrimestru';
import AnalizeClienti from '../Analize';


export default class ClientiLoiali extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
      listLoiali:[],
      
        
       mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
       { id: 'avc', label: 'Analiza de vanzari si client (AVC)', color: '#900DCB' },
       { id: 'analizaclientilornoi', label: 'Analiza clientilor noi, loaiali si pierduti', color: '#900DCB' },
       { id: 'segmentareclienti', label: 'Segmentare clienti in functie de stare', color: '#900DCB' }
       ]
}
    }

     componentDidMount(){
        this.getClientiLoiali()
    }

    getClientiLoiali = async() =>{
        let a = new AnalizeClienti();


        let cL = await  a.clientiLoiali()  

        // console.log('cA :', cL);
        this.setState({
            listLoiali:cL
        })
    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }

  
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
             
                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Clienti loiali</h1>
     
        <div>
      
                {this.state.listLoiali.length === 0 && <span style={{color:'red'}}>{this.dictionary.financiarContabil.nuExista}</span>}
                <List>
                        {this.state.listLoiali.map((l,idx)=>{
                            return(
                               
                                 
                           
                                <ListItem key={idx} style={{textAlign:'center', justifyContent:'center'}}> 
                                    <span className='pm-title'>{l}</span>
                                </ListItem>
                            )
                        })}
                    </List>
            </div>
         </div>
        );
       }
}